'use client';
import Head from 'next/head';

// Definir un componente Section para reutilizar
const Section = ({ id, title, content = [], imgSrc, imgAlt }) => (
  <div id={id} className="mt-10">
    <h3 className="text-2xl font-bold dark:text-blue-100 text-neutral-950">{title}</h3>
    <div className="dark:text-gray-300 text-neutral-800 text-base mt-2">
      {content.map((para, index) => (
        <p key={index} className="mt-2">
          {para}
        </p>
      ))}
    </div>
    <div className="grid min-h-[140px] w-full place-items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">
      <img className="object-cover object-center w-full h-96" src={imgSrc} alt={imgAlt} />
      <p className="mt-2 text-sm text-gray-600">{imgAlt}</p>
    </div>
  </div>
);

const article = {
  imageUrl: 'https://storage.googleapis.com/drago-imagenes-bucket/TopOpenlyQueerVisualArtists.webp',
};

const TopOpenlyQueerVisualArtists = ( {
  // Declare variables using const
   title = 'Top 5 openly queer visual artists and the art movement',
   description = 'A deep dive into supporting new artists and purchasing their artworks.',
   category = ['Arts', 'LGBTQ'],
   tags = ['Art', 'Artists', 'Support', 'New Artists'],
}) => {
  return (
    <>
  <Head>
    <title>Top 5 Openly Queer Visual Artists and the Art Movement</title>
    <meta name="description" content="Explore the top 5 openly queer visual artists and how their work is influencing the art movement. Learn about their unique artistic perspectives and contributions to the cultural landscape." />
    <meta name="author" content="dravvt" />
    
    {/* Meta para redes sociales */}
    <meta property="og:title" content="Top 5 Openly Queer Visual Artists and the Art Movement" />
    <meta property="og:description" content="Explore the top 5 openly queer visual artists and how their work is influencing the art movement. Learn about their unique artistic perspectives and contributions to the cultural landscape." />
    <meta property="og:image" content="https://storage.googleapis.com/drago-imagenes-bucket/TopOpenlyQueerVisualArtistsnail.webp" />
    <meta property="og:url" content="https://dravvt.com/blog/top-5-openly-queer-visual-artists-and-the-art-movement" />
    
    {/* Meta para Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Top 5 Openly Queer Visual Artists and the Art Movement" />
    <meta name="twitter:description" content="Explore the top 5 openly queer visual artists and how their work is influencing the art movement. Learn about their unique artistic perspectives and contributions to the cultural landscape." />
    <meta name="twitter:image" content="https://storage.googleapis.com/drago-imagenes-bucket/TopOpenlyQueerVisualArtistsnail.webp" />
    <meta name="twitter:url" content="https://dravvt.com/blog/top-5-openly-queer-visual-artists-and-the-art-movement" />
  </Head>


    <div>
      <div className="dark:bg-gray-900 bg-transparent border border-neutral-950 text-neutral-950 p-4 rounded-lg shadow-md mb-4 max-w-xs mx-auto text-xs dark:text-gray-400 flex flex-col space-y-2">
        <h1 className="text-lg font-bold text-neutral-950 dark:text-white">{title || 'Default Title'}</h1>
        <p className="font-medium text-orange-600 dark:text-orange-400">Category: {category.join(', ')}</p>
        <p className="dark:text-gray-300 text-neutral-700">{description}</p>
        <p className="font-medium text-blue-500">Tags: {tags.join(', ')}</p>
      </div>
      <div className="article-content">
        <div className="max-w-screen-xl mx-auto p-5 sm:p-8 md:p-12 relative">
          <div
            className="bg-cover bg-center h-64 text-center overflow-hidden"
            style={{
              height: '450px',
              backgroundImage: `url(${article.imageUrl})`,
            }}
          ></div>
          <div className="max-w-2xl mx-auto">
            <div className="mt-3 bg-transparent rounded-b lg:rounded-b-none lg:rounded-r flex flex-col justify-between leading-normal">
              <a
                href="#"
                className="text-base text-indigo-600 uppercase font-medium hover:text-gray-900 transition duration-500 ease-in-out"
              >
                Arts
              </a>
              ,{' '}
              <a
                href="#"
                className="text-xs text-indigo-600 uppercase font-medium hover:text-gray-900 transition duration-500 ease-in-out"
              >
                Technology
              </a>
              <p></p>
              <p className="text-gray-700 text-xs mt-2">Written By: Dravvt</p>
              <div className="dark:bg-gray-900 bg-transparent border border-neutral-950 p-4 rounded-lg shadow-md mb-4 max-w-md mx-auto text-base text-gray-400 flex flex-col space-y-2">
                <h3 className="text-lg font-semibold text-neutral-950 dark:text-blue-100 mb-3">Topics Covered:</h3>
                <ul className="list-disc pl-5">
                  <li>
                    <a href="#What-Does-It-Mean-to-Be-Queer?" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      What Does It Mean to Be Queer?
                    </a>
                  </li>
                  <li>
                    <a href="#What-is-a-queer-art-movement" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      What is a queer art movement
                    </a>
                  </li>
                  <li>
                    <a href="#What-percentage-of-artists-are-queer" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      What percentage of artists are queer
                    </a>
                  </li>
                  <li>
                    <a href="#Top-5-openly-queer-visual-artists" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      Top 5 openly queer visual artists
                    </a>
                  </li>
                  <li>
                    <a href="#Keith-Haring" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      Keith Haring
                    </a>
                  </li>
                  <li>
                    <a href="#David-Wojnarowicz" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      David Wojnarowicz
                    </a>
                  </li>
                  <li>
                    <a href="#Catherine-Opie" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      Catherine Opie
                    </a>
                  </li>
                  <li>
                    <a href="#Nan-Goldin" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      Nan Goldin
                    </a>
                  </li>
                  <li>
                    <a href="#Felix-Gonzalez-Torres" className="dark:text-gray-200 text-neutral-700 hover:text-blue-500 dark:hover:text-gray-600">
                      Felix Gonzalez-Torres
                    </a>
                  </li>
                </ul>
              </div>

              <Section
                id="What-Does-It-Mean-to-Be-Queer?"
                title="#1. What Does It Mean to Be Queer?"
                content={[
                  'Being queer is a term used to describe individuals whose gender identity or sexual orientation doesn\'t fit traditional societal norms. It\'s an inclusive label that covers a wide range of identities, such as lesbian, gay, bisexual, transgender, non-binary, genderqueer, and more.',
                  'Queer people may identify in many ways that don\'t conform to the conventional male-female gender binary. As a result, they often face challenges such as discrimination, harassment, and violence.',
                  'Queer individuals may also encounter difficulties accessing healthcare, employment, and other essential services. These challenges can make it harder to fully participate in society.',
                  'Despite these obstacles, many queer individuals find strength and solidarity within their communities. They work towards building a more inclusive and accepting society.',
                  'The ultimate goal is for everyone to live freely and authentically, embracing their identity without fear of judgment or discrimination.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/What-Does-It-Mean-to-Be-Queer.webp"
                imgAlt="Open hands with question marks emerging, symbolizing the exploration of what it means to be queer"
              />

              <Section
                id="What-is-a-queer-art-movement"
                title="#2. What is a queer art movement"
                content={[
                  'The queer art movement is a cultural and social movement that emerged in the late 20th century, focused on exploring LGBTQ+ themes, identities, and experiences. It challenges traditional societal norms by rejecting heteronormative and cisnormative standards in art.',
                  'Queer artists express themselves through various mediums, including painting, sculpture, photography, and performance art. They aim to disrupt dominant cultural narratives and celebrate the diversity of queer life, offering new perspectives on sexuality, gender, and identity.',
                  'The queer art movement has played a pivotal role in increasing LGBTQ+ visibility, fostering acceptance, and challenging prejudice. It continues to inspire artists, activists, and communities globally to create inclusive spaces and promote social change.',
                  'By showcasing the richness of queer experiences, the movement helps redefine art as a platform for advocacy, self-expression, and equality. Its influence remains strong, encouraging ongoing dialogue about diversity and inclusion in the arts.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/what-is-a-queer-art-movement.webp"
                imgAlt="People exploring an exhibition about the Queer Art Movement, showcasing LGBTQ+ themes and artistic expressions"
              />

              <Section
                id="What-percentage-of-artists-are-queer"
                title="What percentage of artists are queer"
                content={[
                  'A significant number of artists are associated with the queer community. According to a recent survey, approximately 20% of artists identify as queer. This includes individuals who identify as lesbian, gay, bisexual, transgender, or queer/questioning.',
                  'The percentage of queer artists varies depending on the medium. For example, queer representation is higher in visual arts compared to music or theater.',
                  'Additionally, a higher percentage of queer artists are women compared to men in the community.',
                  'The art world has long been a space of acceptance for the queer community. Many queer artists have used their work to express their identities and personal experiences.',
                  'Their contributions have not only enriched the art world but also helped shape the contemporary art landscape, promoting greater inclusivity and understanding.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/What-percentage-of-artists-are-queer.webp"
                imgAlt="A queer artist smiling, representing the diverse identities within the art world, exploring the percentage of queer artists."
              />

              <Section
                id="Why-many-artists-are-queer"
                title="#4. Why many artists are queer"
                content={[
                  'Artists have always been known for their creativity, and it’s no surprise that many of them identify as queer. Studies show that a significant portion of artists tend to lean towards non-heteronormative sexualities and gender identities.',
                  'Art, as a form of expression, allows individuals to explore and break boundaries, which resonates with the queer community. Many queer artists have used their work to reflect their personal struggles, identities, and challenges.',
                  'Throughout history, art has provided a safe space for self-expression, and the queer community has found solace in this freedom.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Why-many-artists-are-queer.webp"
                imgAlt="Artistic expression in a studio by an openly queer artist, symbolizing the connection between creativity and queer identity"
              />

              <Section
                id="Keith-Haring"
                title="#5. Keith Haring"
                content={[
                  'Keith Haring was a pioneering American artist and social activist known for his graffiti-inspired artwork that explored themes of sexuality, HIV/AIDS, and social justice. His bold and vibrant works often depicted figures with dynamic, fluid lines and were influenced by street art and pop culture.',
                  'Haring was openly gay and used his art as a form of activism, addressing issues such as LGBTQ+ rights and the AIDS crisis, which greatly impacted his community.',
                  'His iconic "radiant baby" became a symbol of hope and resilience, and his contributions continue to influence artists and activists alike.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Keith-Haring.webp"
                imgAlt="Keith Haring standing in front of one of his signature vibrant artworks."
              />

              <Section
                id="David-Wojnarowicz"
                title="David Wojnarowicz"
                content={[
                  'David Wojnarowicz was an influential American artist, writer, and activist who addressed issues of identity, sexuality, and AIDS in his works. As a queer man living through the AIDS epidemic, Wojnarowicz’s work captured the urgency and frustration of the crisis, often using disturbing imagery to provoke a response.',
                  'His art was a direct challenge to the political and social status quo, advocating for LGBTQ+ rights and raising awareness about the AIDS epidemic.',
                  'Wojnarowicz’s work continues to resonate, and his legacy as both an artist and an activist remains influential in the fight for LGBTQ+ visibility and equality.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/David-Wojnarowicz.webp"
                imgAlt="David Wojnarowicz in front of his striking artwork, expressing themes of AIDS and activism."
              />

              <Section
                id="Catherine-Opie"
                title="Catherine Opie"
                content={[
                  'Catherine Opie is an American photographer known for her portraits of the LGBTQ+ community, as well as her exploration of gender and identity. Her work is deeply personal and often includes images of queer individuals in intimate or social settings, challenging traditional norms of beauty and representation.',
                  'Opie’s photographs address themes of family, community, and identity, and her work continues to redefine portraiture as a medium for social commentary.',
                  'She remains a prominent figure in contemporary art, celebrated for her contributions to the visibility and acceptance of LGBTQ+ identities.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Catherine-Opie.webp"
                imgAlt="Catherine Opie capturing her iconic photographs of queer individuals, exploring themes of identity."
              />

              <Section
                id="Nan-Goldin"
                title="Nan Goldin"
                content={[
                  'Nan Goldin is an American photographer best known for her intimate and raw portraits of her friends, lovers, and the LGBTQ+ community. Goldin’s work documents the realities of queer life, including themes of sexuality, gender, and addiction, with a focus on capturing the authenticity of her subjects.',
                  'Goldin’s groundbreaking work in photography paved the way for more honest and unflinching portrayals of LGBTQ+ experiences in art.',
                  'Her candid approach to photography challenges societal expectations and gives voice to the marginalized, especially within the queer community.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/Nan-Goldin.webp"
                imgAlt="Nan Goldin capturing candid and intimate moments in her photography, bringing the LGBTQ+ experience into focus."
              />

              <Section
                id="Felix-Gonzalez-Torres"
                title="Felix Gonzalez-Torres"
                content={[
                  'Felix Gonzalez-Torres was a Cuban-American artist whose work spanned various mediums, including installations, sculpture, and photography. His work often focused on themes of love, loss, and identity, particularly through the lens of his experience as a gay man living with AIDS.',
                  'Gonzalez-Torres used minimalism and conceptual art to communicate powerful messages about identity, AIDS awareness, and grief. His installations often included everyday objects, like stacks of paper or string lights, to convey complex emotional experiences.',
                  'His art remains a poignant reminder of the intersections between art, activism, and personal identity, and continues to inspire artists today.',
                ]}
                imgSrc="https://storage.googleapis.com/drago-imagenes-bucket/felix-gonzalez-torres-art-with-cat.webp"
                imgAlt="Felix Gonzalez-Torres' art installation featuring simple, yet powerful elements that challenge conventional norms."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};


export default TopOpenlyQueerVisualArtists;

